export default __webpack_public_path__ + "static/media/googleIcon-3b37618c9192fa5f4f4a09e7ed25f7e1.png";